module.exports = __webpack_public_path__ + "img/btn_google_dark_normal_ios.8f343c26.svg";